import { GoogleMap } from "components/GoogleMap";
import { ImageLite } from "shared/components";

import styles from "./Content054.module.scss";

export const Content054 = ({ payload }) => {
  const lng = payload?.longitude ?? "";
  const lat = payload?.latitude ?? "";
  const image = payload?.image ?? {};

  return (
    <div className={styles.wrapper}>
      <div className={styles.block}>
        <GoogleMap lat={lat} lng={lng} />
        <ImageLite image={image} className={styles.image} />
      </div>
    </div>
  );
};

export default Content054;
